import VerificationChecklistAPI from '@/api/verification-checklist.api'

const state = {
  accountChecklistItems: [],

  accountIdentityCheck: {}
}

/** 
 * @type {import('vuex').GetterTree<typeof state>} 
 */
const getters = {
  
}

/** 
 * @type {import('vuex').ActionTree<typeof state>} 
 */
const actions = {
  async getAccountChecklistItems({ commit }, accountId) {
    const response = await VerificationChecklistAPI.getAccountChecklistItems(accountId)

    commit('SET_ACCOUNT_CHECKLIST_ITEMS', response.data)

    return response.data
  },

  async getAccountRepresentativeIdentityCheck({ commit }, accountId) {
    const response = await VerificationChecklistAPI.getAccountRepresentativeIdentityCheck(accountId)

    commit('SET_ACCOUNT_IDENTITY_CHECK', response.data)

    return response.data
  }
}

/** 
 * @type {import('vuex').MutationTree<typeof state>} 
 */
const mutations = {
  SET_ACCOUNT_CHECKLIST_ITEMS(state, accountChecklistItems) {
    state.accountChecklistItems = accountChecklistItems
  },

  SET_ACCOUNT_IDENTITY_CHECK(state, accountIdentityCheck) {
    state.accountIdentityCheck = accountIdentityCheck
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}